import { g as __rest, b as __assign } from '../../../../../../tslib.es6-14c74580.js';
import React__default from 'react';

var WebGamesSection = function (_a) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    return (React__default.createElement("div", { className: 'lobby-left-bottom' },
        React__default.createElement("div", __assign({ className: 'scroll-c-hor' }, rest),
            React__default.createElement("div", { className: 'lobby-item-wr' }, children))));
};

export { WebGamesSection };
